var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    fill: "#B28A4C",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 40,
    fill: "#B28A4C",
    fillOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 28,
    fill: "#B28A4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4493 44.9813L49.9133 38.0053C50.0141 37.8034 50.1692 37.6336 50.3612 37.5149C50.5531 37.3962 50.7743 37.3334 51 37.3334C51.2256 37.3334 51.4468 37.3962 51.6388 37.5149C51.8307 37.6336 51.9858 37.8034 52.0866 38.0053L55.5506 44.9813L63.2946 46.1066C63.518 46.1376 63.7282 46.2308 63.9011 46.3754C64.0741 46.5201 64.2029 46.7105 64.2728 46.9249C64.3428 47.1393 64.351 47.369 64.2966 47.5879C64.2423 47.8068 64.1274 48.0059 63.9653 48.1626L58.3626 53.5893L59.6853 61.256C59.8546 62.24 58.8146 62.9893 57.9253 62.5253L51 58.904L44.0733 62.5253C43.1853 62.9906 42.1453 62.24 42.3146 61.2546L43.6373 53.588L38.0346 48.1613C37.8733 48.0045 37.7592 47.8055 37.7053 47.587C37.6513 47.3686 37.6598 47.1394 37.7297 46.9255C37.7995 46.7116 37.928 46.5216 38.1005 46.3771C38.2729 46.2326 38.4825 46.1393 38.7053 46.108L46.4493 44.9813Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport1);
export default __webpack_public_path__ + "static/media/report1.26fe3a49a83a540edb691c855755b288.svg";
export { ForwardRef as ReactComponent };